import { legalTermsModel } from '~/models';
import { sortedPages } from '~/models/custom-page/model';
import { COBStep } from './ClientOnboarding.constants';
export const stepsTextsPath = 'clientFlow.steps';
export const previewEmptyStateTextsPath = 'clientFlow.previewEmptyState';
// ============ Enums ============
export var PreviewState = /*#__PURE__*/ function(PreviewState) {
    PreviewState["Preview"] = "preview";
    PreviewState["SetupBrand"] = "setupBrand";
    return PreviewState;
}({});
export var Reason = function(Reason) {
    Reason[Reason["PaymentMethod"] = COBStep.paymentMethod] = "PaymentMethod";
    Reason[Reason["MissingAddress"] = COBStep.address] = "MissingAddress";
    Reason[Reason["ReviewServices"] = COBStep.reviewServices] = "ReviewServices";
    Reason[Reason["SelectAPackage"] = COBStep.selectAPackage] = "SelectAPackage";
    Reason["ApproveTermsOfServices"] = "approveTermsOfServices";
    Reason["ReviewerApprove"] = "reviewerApprove";
    Reason["NotAllowedToSign"] = "notAllowedToSign";
    Reason["SampleApprove"] = "sampleApprove";
    Reason["CompleteSignatureFields"] = "completeSignatureFields";
    return Reason;
}({});
const termsOfServiceSteps = [
    COBStep.termsOfService1,
    COBStep.termsOfService2,
    COBStep.termsOfService3,
    COBStep.termsOfService4
];
const MAX_TERMS_OF_SERVICE_STEPS = termsOfServiceSteps.length;
export const termsOfServiceStepAt = (index)=>termsOfServiceSteps[index];
export const termsOfServiceDocumentsOf = (relationship)=>{
    var _ref;
    var _relationship_legalTermsDocuments;
    return (_ref = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.slice(0, MAX_TERMS_OF_SERVICE_STEPS)) !== null && _ref !== void 0 ? _ref : [];
};
export const termsOfServiceIndexOf = (step)=>{
    const index = termsOfServiceSteps.indexOf(step);
    return index === -1 ? undefined : index;
};
const allCustomPageSteps = [
    COBStep.customPage1,
    COBStep.customPage2,
    COBStep.customPage3,
    COBStep.customPage4,
    COBStep.customPage5,
    COBStep.customPage6,
    COBStep.customPage7,
    COBStep.customPage8,
    COBStep.customPage9,
    COBStep.customPage10
];
export const customPageStepIndex = {
    [COBStep.customPage1]: 0,
    [COBStep.customPage2]: 1,
    [COBStep.customPage3]: 2,
    [COBStep.customPage4]: 3,
    [COBStep.customPage5]: 4,
    [COBStep.customPage6]: 5,
    [COBStep.customPage7]: 6,
    [COBStep.customPage8]: 7,
    [COBStep.customPage9]: 8,
    [COBStep.customPage10]: 9
};
export const customPageStep = (index)=>allCustomPageSteps[index];
export const isCustomPageStep = (step)=>step in customPageStepIndex;
export function getStepName(step, relationship, texts) {
    let addressKind = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'business';
    const getTermsOfServiceName = (index)=>{
        var _relationship_legalTermsDocuments;
        const document = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments[index];
        const termsName = document && legalTermsModel.documentName(document);
        if (termsName) {
            return texts.reviewTermsWithName({
                termsName
            });
        }
        return texts.reviewTermsOfService();
    };
    switch(step){
        case COBStep.welcome:
        case COBStep.introduction:
            return texts.introduction();
        case COBStep.selectAPackage:
            return texts.selectAPackage();
        case COBStep.reviewServices:
            return texts.reviewServices();
        case COBStep.approveTerms:
            return texts.approveTerms();
        case COBStep.paymentMethod:
            return texts.paymentMethod();
        case COBStep.address:
            return addressKind === 'business' ? texts.addressBusiness() : texts.addressIndividual();
        case COBStep.allSet:
            return texts.allSet();
        case COBStep.signAndApprove:
            return texts.signAndApprove();
        case COBStep.termsOfService1:
            return getTermsOfServiceName(0);
        case COBStep.termsOfService2:
            return getTermsOfServiceName(1);
        case COBStep.termsOfService3:
            return getTermsOfServiceName(2);
        case COBStep.termsOfService4:
            return getTermsOfServiceName(3);
        default:
            {
                if (isCustomPageStep(step)) {
                    var _relationship_customPages, _ref;
                    var _pages_index;
                    const index = customPageStepIndex[step];
                    const pages = sortedPages((_relationship_customPages = relationship.customPages) !== null && _relationship_customPages !== void 0 ? _relationship_customPages : []);
                    return (_ref = (_pages_index = pages[index]) === null || _pages_index === void 0 ? void 0 : _pages_index.pageTitle) !== null && _ref !== void 0 ? _ref : texts.customPage();
                }
                return '';
            }
    }
}
